<template>
  <div class="boost-manager">
    <div v-if="isMobileTabletDevice" v-show="isVisualizationLoaded" id="boostBadgeContainer" ref="badge" />
    <div id="boostContainer" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Boost',
  computed: {
    ...mapState(['isMobile', 'isTablet', 'config', 'isVisualizationLoaded']),
    ...mapGetters('user', ['user', 'isLoggedIn']),
    sessionToken() {
      return this.user.sessionToken;
    },
    isMobileTabletDevice() {
      return this.isMobile || this.isTablet;
    },
    userLogged() {
      return this.user.profile.logged || this.isLoggedIn;
    },
  },
  watch: {
    userLogged() {
      this.configureBoost();
    },
    isVisualizationLoaded(value) {
      if (value && this.isMobileTabletDevice) {
        this.calcBadgeStyle();
      }
    },
  },
  mounted() {
    this.configureBoost();
  },
  methods: {
    calcBadgeStyle() {
      const header = document.getElementsByClassName('header-options')[0];
      const { badge } = this.$refs;
      const lengthOfIcons = Array.from(header.childNodes).filter((node) => node.nodeName !== '#comment').length;
      badge.style.left = this.isMobile ? `${34 * lengthOfIcons}px` : `${8 + 34 * lengthOfIcons}px`;
    },
    configureBoost() {
      const boostPayload = this.getBoostData();
      if (this.config.playerId) {
        boostPayload.externalProfileId = this.config.playerId;
      }

      if (this.user.profile.id) {
        boostPayload.profileId = this.user.profile.id;
      }

      if (this.isMobileTabletDevice) {
        boostPayload.badgeContainerId = 'boostBadgeContainer';
        this.calcBadgeStyle();
      }

      if (window.NSoftBoost) window.NSoftBoost.configure(boostPayload);
    },
    getBoostData() {
      const boostConfig = this.config.ui.config.boost;
      const authToken = this.sessionToken ? this.sessionToken : this.user.auth.token;
      return {
        tenantId: boostConfig.tenantId,
        modulesTheme: boostConfig.theme,
        environment: process.env.NODE_ENV,
        modulesContainerId: 'boostContainer',
        authorizationToken: authToken,
        widget: this.isMobileTabletDevice ? 'widgetL6M' : 'widgetL6',
        badgeSize: 'small',
        language: this.config.locale,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.boost-manager {
  padding: 0;

  #boostBadgeContainer {
    position: absolute;
    display: flex;
    align-items: center;
    top: 5px;
  }

  #boostContainer {
    height: 705px;
  }
}
.layout-compact {
  .boost-manager {
    #boostContainer {
      float: left;
      width: 100%;
      max-width: 840px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100vh;
      z-index: 99;
      padding-left: 8px;
    }
  }
}
@media (max-width: 640px) {
  .boost-manager {
    #boostContainer {
      float: left;
      width: 100%;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100vh;
      z-index: 99;
    }
    :deep(#boostBadgeContainer) {
      #NSoftBoostBadgeIframe {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
}
@media (min-width: 1483px) {
  .boost-manager {
    #boostContainer {
      height: 863px;
    }
  }
}
</style>
